<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="movements"
      :loading="loading"
      class="elevation-1"
      hide-actions
      :no-data-text="$t('message.datatable.noDataText')"
    >
      <template v-slot:items="props">
        <td>{{ props.item.fecha }}</td>
        <td>{{ props.item.nombre }}</td>
        <td>{{ props.item.estado_hasta_alias }}</td>
        <td v-html="props.item.observaciones"></td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import Licenses from '@/apiClient/Licenses'

  export default {
    props: {
      idLicense: {
        type: [Number, String],
        default: 0
      }
    },
    data () {
      return {
        licenses: Licenses,
        loading: false,
        headers: [
          {
            text: this.$t('message.LincensesApprovalPendingComponent.labels.request'),
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: this.$t('message.LincensesApprovalPendingComponent.labels.actionDoneBy'),
            align: 'left',
            sortable: false,
            value: 'name'
          },{
            text: this.$t('message.LincensesApprovalPendingComponent.labels.state'),
            align: 'left',
            sortable: false,
            value: 'name'
          },{
            text: this.$t('message.LincensesApprovalPendingComponent.labels.observations'),
            align: 'left',
            sortable: false,
            value: 'name'
          },
        ],
        movements: []
      }
    },
    created() {
      this.licenses = new Licenses()
      this.loading = true
      this.licenses.getLicenseMovements(this.idLicense).then(res => {
        this.movements = res.data.results.data
        this.loading = false
      }).catch(error => {
        this.loading = false
      })
    }
  }
</script>